export const availableFilters = ['iso', 'degree', 'gasDemand'] as const;

export const weightedFilterConfigs: Record<
  (typeof availableFilters)[number],
  { availableContinents: string[] }
> = {
  iso: {
    availableContinents: ['NA', 'EUR', 'ASIA', 'MEX'],
  },
  degree: {
    availableContinents: ['NA', 'EUR'],
  },
  gasDemand: {
    availableContinents: ['NA'],
  },
};
